import { render, staticRenderFns } from "./add-size.vue?vue&type=template&id=5ebaff40&"
import script from "./add-size.vue?vue&type=script&lang=js&"
export * from "./add-size.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports